import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-types-papi';

export const setIsRepositioningProfileHero = createAction(
  'PROFILE_HERO_EDITOR.SET_IS_REPOSITIONING'
);

export const setProfileHeroDeviation = createAction<PapiDeviation>(
  'PROFILE_HERO_EDITOR.SET_DEVIATION'
);

export const updateProfileHeroCropArea = createAction<{
  x: number;
  y: number;
  width: number;
  height: number;
}>('PROFILE_HERO_EDITOR.UPDATE_CROP_AREA');

export const saveProfileHero = createAction('PROFILE_HERO.SAVE', () => ({}));
export const deleteProfileHero = createAction(
  'PROFILE_HERO.DELETE',
  () => ({})
);
